import { useTheme } from 'styled-components';
import getConfig from 'next/config';
import type { DealerSubtitleProps } from './DealerSubtitle.typed';
import * as Styled from './DealerSubtitle.styled';

// Dealers with an established year of '0' are considered to have no established year
const ESTABLISHED_YEAR_UNDEFINED_DEFAULT = '0';

export const DealerSubtitle = ({
  isTrustedDealer,
  franchiseType,
  /**
   * Established year as a string, or '0' to indicate undefined
   */
  establishedYear,
}: DealerSubtitleProps) => {
  const theme = useTheme();
  const {
    publicRuntimeConfig: { FEATURE_TDP_UPDATES },
  } = getConfig();

  return (
    <Styled.DealerTitleContainer color="GREY_DARK" size="M14" forwardedAs="div">
      {!FEATURE_TDP_UPDATES && franchiseType}
      {FEATURE_TDP_UPDATES && isTrustedDealer && franchiseType && (
        <>
          <Styled.TrustedBadge
            width="16"
            height="16"
            color={theme.donedeal.colors.GREEN}
            data-testid="trusted-dealer-icon"
            aria-label="Trusted Dealer Badge"
            role="img"
          />
          <Styled.DealerTitleText>
            Trusted {franchiseType}
          </Styled.DealerTitleText>
          {establishedYear &&
            establishedYear !== ESTABLISHED_YEAR_UNDEFINED_DEFAULT && (
              <>
                <Styled.Divider />
                <Styled.Established>
                  {`Est ${establishedYear}`}
                </Styled.Established>
              </>
            )}
        </>
      )}
      {FEATURE_TDP_UPDATES && !isTrustedDealer && franchiseType}
    </Styled.DealerTitleContainer>
  );
};
